import React, { Fragment } from 'react';

const AutzuAccount = ({ city = 'toronto' }) => (
  <Fragment>
    <p>
      There are 4 easy steps to set up your Autzu account and begin
      driving:
    </p>
    <ol>
      <li>
        Download our{' '}
        <a
          className="faq__panel--link"
          href="https://www.autzu.com/signup">
          Autzu app
        </a>{' '}
        and sign up
      </li>
      <li>
        Verify your identity with your driver's license and a picture of
        your face that is clearly visible{' '}
      </li>
      <li>Connect your rideshare driver account</li>
      <li>
        Once you have received notice from the rideshare company that your
        account is active, you can begin booking using the Autzu app!
      </li>
    </ol>
    <p>
      You can click{' '}
      <a
        className="faq__panel--link"
        href="https://www.youtube.com/watch?v=Fg3rsZtBAZU&list=PLypJbLBqp9zicsWFtZd4ILySpShdpxOXu&index=1">
        here
      </a>{' '}
      to view instructions on how to sign up with Autzu.
    </p>
  </Fragment>
);

export default AutzuAccount;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/SignUp/AutzuAccount.js